import { LoadableComponent } from '@src/core/router/lazy-routes/loadable';

// Dashboard (Recharts + chart components — heavy bundle, load on route)
export const DashboardLayout = LoadableComponent(() =>
  import('@src/features/dashboard/components/dashboard-layout').then((m) => ({
    default: m.DashboardLayout,
  }))
);
export const LeadMangmentPage = LoadableComponent(() =>
  import('@src/features/dashboard').then((m) => ({
    default: m.LeadMangmentPage,
  }))
);
export const ProgramsManagementPage = LoadableComponent(() =>
  import('@src/features/dashboard/pages/programs-mangement-page').then((m) => ({
    default: m.ProgramsManagementPage,
  }))
);

// Soon Page =================================================================
export const SoonPage = LoadableComponent(
  () => import('@shared/pages/soon-page')
);
// Auth =================================================================
export const Register = LoadableComponent(
  () => import('@features/auth/pages/register/register')
);
export const Verification = LoadableComponent(
  () => import('@src/shared/pages/verification-page')
);
export const Login = LoadableComponent(
  () => import('@features/auth/pages/login')
);
export const ForgotPassword = LoadableComponent(
  () => import('@features/auth/pages/forget-password/forgot-password')
);
export const AuthCheckMail = LoadableComponent(
  () => import('@features/auth/pages/check-mail/check-mail')
);

// Programs =================================================================
export const Programs = LoadableComponent(
  () => import('@features/programs/pages/list/programslist')
);
export const AddProgram = LoadableComponent(
  () => import('@features/programs/pages/create/add-program')
);

export const Placements = LoadableComponent(
  () => import('@features/placements/pages/list')
);

export const AddPlacement = LoadableComponent(
  () => import('@features/placements/pages/create')
);

// Commission =================================================================
export const Commission = LoadableComponent(
  () => import('@features/commission/pages')
);

// Tasks ================================================================
export const TasksList = LoadableComponent(
  () => import('@features/tasks/pages/list/tasks-list')
);

// Users ================================================================
export const UsersList = LoadableComponent(
  () => import('@features/users/pages/list')
);
export const Roles = LoadableComponent(() =>
  import('@src/features/roles').then((module) => ({
    default: module.Roles,
  }))
);
// Accounting ===========================================================
export const Invoices = LoadableComponent(
  () => import('@features/accounting/pages/invoices/invoices')
);

export const Payments = LoadableComponent(
  () => import('@features/accounting/pages/payments/payments')
);

export const Products = LoadableComponent(
  () => import('@src/features/accounting/pages/products/list/products')
);

// Participants =========================================================
export const ParticipantsTable = LoadableComponent(
  () => import('@features/participants/pages/list/list-participants')
);

export const AllParticipantsTable = LoadableComponent(
  () => import('@features/participants/pages/list/list-participants')
);

export const SingleParticipant = LoadableComponent(
  () => import('@features/participants/pages/detail/single-participant')
);
export const EditParticipant = LoadableComponent(
  () => import('@features/participants/pages/edit')
);
export const ListStages = LoadableComponent(
  () => import('@features/participants/pages/stages')
);

export const ParticipantsPlacements = LoadableComponent(() =>
  import('@features/participants/pages/placements').then((module) => ({
    default: module.ParticipantsPlacements,
  }))
);

// Leads =================================================================
export const Leads = LoadableComponent(
  () => import('@features/leads/pages/list/list-leads')
);
export const SingleLead = LoadableComponent(
  () => import('@features/leads/pages/detail/single-lead')
);

// Settings ==============================================================
export const SettingsLayout = LoadableComponent(() =>
  import('@features/settings/components/settings-layout').then((module) => ({
    default: module.SettingsLayout,
  }))
);
export const ProfileSettings = LoadableComponent(
  () => import('@features/settings/pages/profile')
);
export const CompanyInfo = LoadableComponent(
  () => import('@features/settings/pages/organization')
);
export const Preferences = LoadableComponent(
  () => import('@features/settings/pages/preferences')
);
export const EditOrgInfo = LoadableComponent(
  () => import('@features/settings/pages/organization/edit')
);

export const Branches = LoadableComponent(
  () => import('@features/settings/pages/branches')
);
export const Integration = LoadableComponent(
  () => import('@features/settings/pages/integration')
);
export const BrandTheme = LoadableComponent(
  () => import('@features/settings/pages/brand-theme')
);

export const UserSettingsLayout = LoadableComponent(
  () => import('@features/settings/components/user-settings-layout')
);

export const EditUserInfo = LoadableComponent(
  () => import('@features/settings/pages/user-profile')
);

export const ProfileSettingsActivityLogs = LoadableComponent(
  () => import('@features/settings/pages/profile/activity-logs')
);

export const ProfileSettingsMyTasks = LoadableComponent(
  () => import('@features/settings/pages/profile/tasks')
);

export const ProfileSettingsMyDocuments = LoadableComponent(
  () => import('@features/settings/pages/profile/documents')
);

export const ProfileSettingsMyBankInfos = LoadableComponent(
  () => import('@features/settings/pages/profile/bank-infos')
);

export const ProfileSettingsMyEmplyomentInfo = LoadableComponent(
  () => import('@features/settings/pages/profile/employment')
);

// Conversations ==========================================================
export const ConversationsPage = LoadableComponent(() =>
  import('@features/conversations/pages/conversations-page').then((m) => ({
    default: m.ConversationsPage,
  }))
);
export const ConversationsOnboarding = LoadableComponent(() =>
  import('@features/conversations/pages/conversations-onboarding').then(
    (m) => ({
      default: m.ConversationsOnboarding,
    })
  )
);
export const ConversationsChannels = LoadableComponent(() =>
  import('@features/conversations/pages/conversations-channels').then((m) => ({
    default: m.ConversationsChannels,
  }))
);

// Contacts ===============================================================
export const ContactsWorkspace = LoadableComponent(() =>
  import('@features/contacts/pages/list').then((m) => ({
    default: m.ContactsWorkspace,
  }))
);
export const ContactDetailPage = LoadableComponent(
  () => import('@features/contacts/pages/detail')
);
export const MessageTemplatesPage = LoadableComponent(
  () => import('@features/contacts/pages/templates')
);

// Automations ============================================================
export const KnowledgeBasePage = LoadableComponent(() =>
  import('@features/knowledge-base/pages/knowledge-base-page').then((m) => ({
    default: m.KnowledgeBasePage,
  }))
);
export const KnowledgeBaseWorkspace = LoadableComponent(() =>
  import('@features/knowledge-base/pages/knowledge-base-page').then((m) => ({
    default: m.KnowledgeBaseWorkspace,
  }))
);
export const AgentsWorkspace = LoadableComponent(() =>
  import('@features/ai-agents/pages/agents-workspace').then((m) => ({
    default: m.AgentsWorkspace,
  }))
);

export const AutomationsWorkspace = LoadableComponent(() =>
  import('@features/automations/pages/list').then((m) => ({
    default: m.AutomationsWorkspace,
  }))
);
export const AutomationActivityPage = LoadableComponent(() =>
  import('@features/automations/pages/activity').then((m) => ({
    default: m.AutomationActivityPage,
  }))
);
